export interface AccessTokenPackage {
    accessToken: string;
    refreshToken: string;
};